<article class="card" (click)="clickCard.emit()">
	<div class="card__img">
		<img [src]="venue.coverURL.original | optimizeImage: 'webp' : 686 : 300" width="335" height="150" />
	</div>
	<div class="card__info">
		<div class="card__info__venue">
			<div>
				<h1 class="card__info__title">{{ venue.name }}</h1>
			</div>
			<p class="card__info__address">
				<span>{{ venue.address.value }} </span>
				<!-- <button class="address-redirect" (click)="addressRedirect.emit()">
					<mat-icon svgIcon="porto-bank-icons:address-redirect"></mat-icon>
				</button> -->
			</p>
		</div>
	</div>
	<div style="height: 1px; width: 100%; background-color: #e0e0e0"></div>
	<div class="card__benefits">
		<ui-porto-bank-benefits [benefits]="venue.benefits"></ui-porto-bank-benefits>
		<button mat-button>Ver restaurante</button>
	</div>
</article>
